import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { ClientItem } from 'owa-mail-store';

export default function isProactiveDraft(item: ClientItem | undefined): boolean {
    // TODO: Replace the feature flag with actual backend property when available
    if (!item || !isGlobalFeatureEnabled('mon-copilot-proactive-drafts-view')) {
        return false;
    }

    // Proactive drafts are drafts that are NOT scheduled sends
    return !!(item.IsDraft && !item.DeferredSendTime);
}
